export default "__VITE_ASSET__Ht4nQnao__"